import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Pure validator — marks a control invalid when its value is a string that
 * is empty after being trimmed (i.e. whitespace-only). Returns `null` for
 * non-empty strings and for non-string values (delegates to other validators).
 *
 * Use alongside `Validators.required`: `required` catches `null`/`''`, this
 * catches `'   '`.
 */
export const nonWhitespaceValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (typeof value !== 'string') return null;
  return value.trim().length === 0 ? { whitespace: true } : null;
};
